var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 63,
    viewBox: "0 0 71 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5642 57.93C19.0942 60.36 16.2142 62.03 12.7542 62.47C11.9842 62.6 11.2142 62.6 10.5142 62.6C6.67425 62.6 2.83425 61.32 0.0142471 58.76L2.25425 56.26C4.87424 58.56 8.71424 59.59 12.3042 59.08C14.9242 58.7 16.7242 57.74 17.7442 56.2C18.2542 55.24 18.4442 54.47 18.1242 53.51C17.7442 51.97 16.3942 50.44 14.2242 49.35C13.0042 48.71 11.6642 48.2 10.1242 47.62C7.69425 46.72 5.06425 45.83 3.08425 44.16C0.784247 42.24 -0.305755 39.68 0.0742446 37.18C0.654245 34.3 3.21424 31.74 6.66424 30.59C11.5942 28.8 17.8642 29.95 21.7642 33.73L19.3942 36.16C16.3242 33.15 11.7142 32.32 7.74424 33.73C5.24424 34.69 3.71424 36.1 3.45424 37.83C3.19424 39.17 3.77425 40.33 5.18425 41.48C6.78425 42.82 8.89424 43.59 11.2042 44.49C12.7442 45 14.3442 45.58 15.8742 46.35C18.6942 47.82 20.8042 50.19 21.4442 52.56C21.9542 54.35 21.5742 56.4 20.5442 57.94L20.5642 57.93Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSh);
export default __webpack_public_path__ + "static/media/SH.e5109bdf0e1e60100c488cbdac2d16f7.svg";
export { ForwardRef as ReactComponent };